/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import Lottie from 'react-lottie';
import PropTypes from 'prop-types';

const divStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const UncontrolledLottie = (props) => {
  const {
    width,
    height,
    callback,
    absolute,
    file,
  } = props;

  const animationData = require(`./${file}.json`);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div style={absolute && divStyle}>
      <Lottie
        options={defaultOptions}
        width={width}
        height={height}
        eventListeners={[
          {
            eventName: 'complete',
            callback,
          },
        ]}
      />
    </div>
  );
};

UncontrolledLottie.defaultProps = {
  file: null,
  width: null,
  height: null,
  callback: null,
  absolute: null,
};

UncontrolledLottie.propTypes = {
  file: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  callback: PropTypes.string,
  absolute: PropTypes.string,
};

export default UncontrolledLottie;
